import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import { Button, Typography } from "@mui/material";
import { DataGrid } from '@mui/x-data-grid';
import { useNavigate } from "react-router-dom";
import { IOSSwitch } from "../../Gen/Switch";
import "./Order.css";
import IconButton from '@mui/material/IconButton';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getOrders } from "../../../Store/Features/Order/orderSlice";
import CircularProgress from '@mui/material/CircularProgress';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
import Divider from '@mui/material/Divider';
import MenuIcon from '@mui/icons-material/Menu';
import SearchIcon from '@mui/icons-material/Search';
import DirectionsIcon from '@mui/icons-material/Directions';

import Pagination from '@mui/material/Pagination';
import PaginationItem from '@mui/material/PaginationItem';
import {

  gridPageCountSelector,
  gridPageSelector,
  useGridApiContext,
  useGridSelector,
} from '@mui/x-data-grid';

export const OrderTable = () => {
  const dispatch = useDispatch();
  const { slug } = useParams();
  const Orders = useSelector(state => state.ordersSlice.value);
  const Loading = useSelector(state => state.ordersSlice.loading);
  const [searchQuery, setSearchQuery] = React.useState("");
  const [filterData, setFilteredData] = useState([]);
  const [sort, setSort] = useState();
  function isObjEmpty(obj) {
    return Object.keys(obj).length === 0;
  }
  useEffect(() => {
    if (isObjEmpty(Orders)) {
      dispatch(getOrders(slug));
    }
  }, []);
  const navigate = useNavigate();



  useEffect(() => {
    setFilteredData(Orders);
  }, [Orders]);

  useEffect(() => {
    searchFilter(searchQuery);
  }, [searchQuery]);

  useEffect(() => {
    sorted(sort);
  }, [sort]);


  const searchFilter = (text) => {
    if (text) {
      const newData = filterData.filter((item, index) => {
        const itemMake = item.customer_email ? item.customer_email.toUpperCase() : "".toUpperCase();

        // const itemReg = item.Reg ? item.Reg.toUpperCase() : ''.toUpperCase();
        // const itemModel = item.model ? item.model.toUpperCase() : ''.toUpperCase();
        const textData = text.toUpperCase();
        if (itemMake.indexOf(itemMake) > -1) {
          return itemMake.indexOf(textData) > -1;
        }
      });
      setFilteredData(newData);
      setSearchQuery(text);
    } else {
      setFilteredData(Orders);
      setSearchQuery(text);
    }
  };

  const sorted = (temp) => {
    let temp1 = [...filterData];
    switch (temp) {
      case 10:
        temp1?.sort((a, b) => {
          return b.id - a.id;
        });
        setFilteredData(temp1);
        break;
      default: return;

    }

  };



  const columns = [
    { field: 'id', headerName: 'No', flex: 1 },
    {
      field: 'customer_email',
      headerName: 'Customer Order',
      flex: 1,

    },

    {
      field: ' ',
      headerName: '',
      width: 50,
      renderCell: (params) => (

        <IconButton aria-label="upload picture" component="label" onClick={() => navigate(`/Order/${params.row.id}`)}>
          <VisibilityIcon sx={{ color: '#EC492F' }} />
        </IconButton>

      )
    },
  ];


  return (<>
    {Loading ? (<Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", justifyContent: "center", height: "40vh" }} > <CircularProgress /></Box >) : (
      <Box sx={{ position: "relative" }}>
        <Box sx={{ display: "flex", width: "37%", alignItems: "center", gap: "12px", position: "absolute", right: 0, top: "-57px" }}>
          <Typography className="Active">Sort By: </Typography>
          <Select1 value={sort} setValue={setSort} />
          <CustomizedInputBase value={searchQuery} setValue={setSearchQuery} />
        </Box>
        <Box className="Table">
          <DataGrid

            rows={filterData}
            columns={columns}

            initialState={{
              ...filterData.initialState,
              pagination: { paginationModel: { pageSize: 10 } },
            }}
            autoHeight
            disableRowSelectionOnClick
            slots={{
              pagination: CustomPagination,
            }}
          />
        </Box>
      </Box>
    )
    }
  </>

  );
};



function Select1({ value, setValue }) {


  return (

    <FormControl >
      <Select
        value={value}
        onChange={e => setValue(e.target.value)}
        sx={{ width: "162px", height: "34px", border: "1px solid #858C94" }}
        displayEmpty
        className="SelectText"
        inputProps={{ 'aria-label': 'Without label' }}
      >
        <MenuItem value="">
          <em>None</em>
        </MenuItem>
        <MenuItem value={10} >Most Recent</MenuItem>
      </Select>
    </FormControl>

  );
}

export default function CustomizedInputBase({ value, setValue }) {
  return (
    <Paper
      component="form"
      sx={{
        p: '2px 4px', display: 'flex', alignItems: 'center', width: 228, height: "34px", border: "1px solid #858C94", "box-sizing": "border-box", borderRadius: "8px"
      }}
      elevation={0}
    >
      <IconButton type="button" sx={{ p: '10px' }} aria-label="search">
        <SearchIcon />
      </IconButton>
      <InputBase
        sx={{ ml: 1, flex: 1 }}
        placeholder="Search..."
        inputProps={{ 'aria-label': 'search google maps' }}
        className="plh-text"

        value={value}
        onChange={e => setValue(e.target.value)}
      />
    </Paper >
  );
}


const getColor = (status) => {
  switch (status) {
    case "Paid":
      return "#6CA430";
    case "Cancelled":
      return "#EC492F";
    case "Pending":
      return "#CFAF05";
    default:
      return;

  }
};

function CustomPagination() {
  const apiRef = useGridApiContext();
  const page = useGridSelector(apiRef, gridPageSelector);
  const pageCount = useGridSelector(apiRef, gridPageCountSelector);

  return (
    <Pagination

      page={page + 1}
      count={pageCount}
      // @ts-expect-error
      sx={{
        '& .Mui-selected': {
          backgroundColor: 'transparent !important',
          color: '#ec492f',
        },
      }}
      renderItem={(props2) => <PaginationItem className="paginationText"  {...props2} />}
      onChange={(event, value) => apiRef.current.setPage(value - 1)}
    />
  );
}